import searchConstants from "../../../shared/constants/search";

const {
  FEED_TITLES: { MOVIE, TV_SHOW, LIVE_SPORTS },
} = searchConstants;

// Action types
export const LOAD_SEARCH_RESULTS = "LOAD_SEARCH_RESULTS";
export const MANUAL_SEARCH_TRIGGERED = "MANUAL_SEARCH_TRIGGERED";

// Action methods
export const loadSearchContent = (data) => {
  if (data) {
    return {
      type: LOAD_SEARCH_RESULTS,
      content: [
        {
          feedTitleKey: LIVE_SPORTS,
          feedData:
            data[2]?.status === "fulfilled"
              ? data[2]?.value?.containers?.filter((item) => item?.layout && item?.metadata) ?? []
              : [],
          totalItems: data[2]?.value?.total,
        },
        {
          feedTitleKey: TV_SHOW,
          feedData:
            data[1]?.status === "fulfilled"
              ? data[1]?.value?.containers?.filter((item) => item?.layout && item?.metadata) ?? []
              : [],
          totalItems: data[1]?.value?.total,
        },
        {
          feedTitleKey: MOVIE,
          feedData:
            data[0]?.status === "fulfilled"
              ? data[0]?.value?.containers?.filter((item) => item?.layout && item?.metadata) ?? []
              : [],
          totalItems: data[0]?.value?.total,
        },
      ],
    };
  }
};

export const triggerManualSearch = (isManualSearch) => {
  return { type: MANUAL_SEARCH_TRIGGERED, isManualSearch };
};
